import React, { useEffect, useState } from 'react';
import './EventDetails.css';
import Popup from './Popup';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button, Link, Tooltip, CircularProgress } from '@material-ui/core';
import CustomAlert from './CustomAlert';
import { newPayment } from './Models/ProductsModel';
import { MetaTags } from 'react-meta-tags';
import PlusIcon from '@material-ui/icons/Add';
import MinusIcon from '@material-ui/icons/Remove';
import server from '../Backend/axios';
import { getSportEventDetails } from '../Backend/firebase/sport-event';
import DetailsSkeleton from './DetailsSkeleton';
import { createPaymentDocument, updatePaymentDocument } from '../Backend/firebase/payment';
import BookingUserInfo from './BookingUserInfo';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function AddMetaTags({ record, imageUrl }) {
    return (
        <>
            <div className="wrapper">
                <MetaTags>
                    <meta charSet="utf-8" />
                    <meta name="description" content={record?.tournamentName} />
                    <meta property="og:description" content={record?.tournamentName} />
                    <meta property="og:title" content={record?.tournamentName} />
                    <meta property="og:image" itemprop="image primaryImageOfPage" content={"https://kaipsoolretail.web.app/assets/kaipsool.png"} />
                    <meta property="og:image:height" content="200" />
                    <meta property="og:image:width" content="200" />
                    <meta name="twitter:description" property="og:description" content={record?.tournamentName} />
                    <meta name="twitter:title" content={record?.tournamentName} />
                    <meta name="twitter:image" content={"https://kaipsoolretail.web.app/assets/kaipsool.png"} />
                    <meta name="og:url" content={window.location.href} />
                    <title>{record?.tournamentName}</title>
                    <link rel="image_src" href={"https://kaipsoolretail.web.app/assets/kaipsool.png"} />
                    <link rel="canonical" href={window.location.href} />
                </MetaTags>
            </div>
        </>
    )
}


function SportBookingDetails() {
    const { uid } = useParams();
    const [eventDetails, setEventDetails] = useState(null);
    const dispatch = useDispatch();
    const history = useHistory();
    const [openPopup, setOpenPopup] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [entryTicketFields, setEntryTicketFields] = useState([]);
    const [renderTickets, setRenderTickets] = useState([]);
    const [isPayemntLoading, setIsPayemntLoading] = useState(false);
    useEffect(() => {
        // Returns the cleanup function
        return () => {
            const metaTag = document.querySelector(`meta[content="Web site created using create-react-app"]`);
            if (metaTag) {
                metaTag.remove();
            }
        }
    }, []);

    useEffect(async () => {
        try {
            const getEventsData = await getSportEventDetails(uid);
            setEventDetails(getEventsData.event);
        } catch(error) {
            console.log("Error Occur in Get Sport Events", error)
        }
    }, []);

    useEffect(() => {
        if(entryTicketFields.length > 0) {
            uniqueTickets()
        }
    }, [entryTicketFields]);

    const uniqueTickets = () => {
        if(entryTicketFields.length > 0) {
            const uniqueObjects = {};

            entryTicketFields.forEach(entry => {
                const { uniqueId, ticketCount, ...rest } = entry;
                
                if (uniqueObjects[uniqueId]) {
                    uniqueObjects[uniqueId].ticketCount += ticketCount;
                } else {
                    uniqueObjects[uniqueId] = { uniqueId, ticketCount, ...rest };
                }
            });

            let updatedRenderValue = Object.values(uniqueObjects);
            setRenderTickets(updatedRenderValue);
        }
    };

    const handleAddEntryFee = (uniqueId, entryCategory, entryFees, index) => {
        setEntryTicketFields([
            ...entryTicketFields,
            {
                uniqueId: uniqueId,
                entryCategory: entryCategory,
                entryFees: entryFees,
                ticketCount: 1
            }
        ])
    }
    const handleRemoveEntryFee = (uniqueId) => {
        console.log("entryTicketFields.length",entryTicketFields.length)
        if(entryTicketFields.length > 0) {
            const values = [...entryTicketFields]
            const getUpdatedArr = removeByAttr(values, 'uniqueId', uniqueId);
            setEntryTicketFields(getUpdatedArr)
        }
    }
    var removeByAttr = function(arr, attr, value){
        var i = arr.length;
        while(i--){
           if( arr[i] 
               && arr[i].hasOwnProperty(attr) 
               && (arguments.length > 2 && arr[i][attr] === value ) ){ 
    
               arr.splice(i,1);
    
           }
        }
        return arr;
    }
    const totalSum = entryTicketFields.reduce((acc, entry) => {
        const entryFees = parseFloat(entry.entryFees);
        const ticketCount = entry.ticketCount;
        return acc + (entryFees * ticketCount);
    }, 0);

    const generateRandomOrderNumber = () =>  {
        var randomNumbers = [];
        for (var i = 1; i <= 6; i++) {
          var randomNumber = Math.floor(Math.random() * 6) + 1;
          if (!randomNumbers.includes(randomNumber)) {
            randomNumbers.push(randomNumber);
          }
        }
        return "receipt#_"+randomNumbers.join("");
      }

    const initPayment = (order) => {
        try {
            var options = { 
                "key": "rzp_test_1EIdP6teFJVkvg",  
                "amount": order.amount,  
                "currency": order.currency, 
                "name": eventDetails?.tournamentName, 
                "description": `Pay & Checkout this ${eventDetails?.tournamentName}`, 
                "image": "https://kaipsoolretail.web.app/static/media/Logo.4089e2c3.webp", 
                "order_id": order.id,
                "handler": async function (response){ 
                    const _id = localStorage.getItem('temp_id') ?? '';
                    console.log("This step of Payment Succeeded", response)
                    try {
                        if(response.razorpay_payment_id) {
                            await server.post("/razorpay/verifyOrder", {
                                payment_id: response.razorpay_payment_id,
                                order_id: order.id
                            }).then((res) => {
                                    console.log(res.data);
                                    if (res.status === 200 && res.data.success) {
                                        console.log("Payment Verification Passed => ",res.data);
                                        if(_id && _id != "") {
                                            newPayment._id = _id;
                                            newPayment.paymentId = response.razorpay_payment_id;
                                            newPayment.paymentStatus = 'Captured';
                                            try {
                                                var payment = updatePaymentDocument(newPayment);
                                                if (payment) {
                                                    console.log("Payment Updated Successfully=> ",payment);
                                                    history.push(`/payment-success/${response.razorpay_payment_id}`);
                                                } else {
                                                    console.error("ERROR Occurs in Verify payment Database Entry => ");
                                                    setNotificationMessage('Payment Verification Failed, Please Try Again later!');
                                                    setOpenNotify(true);
                                                    setAlertType('error');
                                                    history.push('/payment-failed');
                                                }
                                            }  catch (error) {
                                                console.error("ERROR Occurs in Verify payment Entry => ", error);
                                                setNotificationMessage('Payment Verification Failed, Please Try Again later!');
                                                setOpenNotify(true);
                                                setAlertType('error');
                                                history.push('/payment-failed');
                                            }
                                        } else {
                                            setNotificationMessage('Payment Verification Failed, Please Try Again later!');
                                            setOpenNotify(true);
                                            setAlertType('error');
                                            history.push('/payment-failed');
                                        }
                                    } else {
                                        setNotificationMessage('Payment Verification Failed, Please Try Again later!');
                                        setOpenNotify(true);
                                        setAlertType('error');
                                        history.push('/payment-failed');
                                    }
                            }).catch(err => {
                                console.log('Verify Error => ', err)
                                setNotificationMessage('Payment Verification Failed, Please Try Again later!');
                                setOpenNotify(true);
                                setAlertType('error');
                                history.push('/payment-failed');
                            });
                        } else {
                            setNotificationMessage('Internal server Error. Payment Id Not found!!');
                            setOpenNotify(true);
                            setAlertType('error');
                            history.push('/payment-failed');
                        }
                    } catch (error) {
                        console.log('Verify Error => ', error)
                        setNotificationMessage('Internal server Error. Please try again later!!');
                        setOpenNotify(true);
                        setAlertType('error');
                        history.push('/payment-failed');
                    }
                }, 
                "prefill": {
                    "contact":"",  
                    "name": "",   
                    "email": ""  
                }, 
                "notes" : { 
                    "description":"Kaipsool Pharmatech not only serves as a pharmaceutical information platform but also lists sports tournaments, bridging the gap between the sports and health industries for greater synergy."
                },  
                "theme": { 
                    "color": "#000" 
                } 
            };
            const razorpayObject = new window.Razorpay(options);
            razorpayObject.open(); 
            setIsPayemntLoading(false)

            razorpayObject.on('payment.failed', function (response){ 
                console.log("This step of Payment Failed",response); 
                setNotificationMessage('Payment Failed, Please Try Again later!');
                setOpenNotify(true);
                setAlertType('error');
                setIsPayemntLoading(false)
            }); 
        } catch(error) {
            setNotificationMessage('Payment Failed, Please Try Again later!');
            setOpenNotify(true);
            setAlertType('error');
            setIsPayemntLoading(false)
        }
    }

	const createRazorpayOrderRequest = async (userInfo) => {
        console.log('UserInfo',userInfo)
        let totalAmout = totalSum;
        if(totalAmout > 0) {
            setIsPayemntLoading(true)
            setOpenPopup(false);
            try {
                await server.post("/razorpay/createOrder", { 
                    amount: totalAmout * 100, 
                    currency: "INR", 
                    receipt: generateRandomOrderNumber(), 
                    notes:  `Pay & Checkout this ${eventDetails?.tournamentName}`
                }).then((response) => {
                    console.log(response.data);
                    if (response.status === 200 && response.data.success) {
                        console.log("Create Order Passed => ",response.data);
                        newPayment.name = userInfo.name;
                        newPayment.phone = userInfo.phone;
                        newPayment.email = userInfo.email;
                        newPayment.amount = totalAmout * 100;
                        newPayment.currency = "INR";
                        newPayment.tickets = renderTickets;
                        newPayment.events = eventDetails;
                        newPayment.via = 'RazorPay';
                        newPayment.orderId = response.data.data.id;
                        newPayment.paymentStatus = 'Created';
                        try {
                            var payment = createPaymentDocument(newPayment);
                            if (payment) {
                                initPayment(response.data.data);
                            } else {
                                console.error("ERROR Occurs in Create Order Database Entry => ");
                                setNotificationMessage('Something went wrong, Please Try Again later!');
                                setOpenNotify(true);
                                setAlertType('error');
                            }
                        }  catch (error) {
                            console.error("ERROR Occurs in Create Order Entry => ", error);
                            setNotificationMessage('Something went wrong, Please Try Again later!');
                            setOpenNotify(true);
                            setAlertType('error');
                            setIsPayemntLoading(false)
                        }
                    } else {
                        setNotificationMessage('Something went wrong, Please Try Again later!');
                        setOpenNotify(true);
                        setAlertType('error');
                        setIsPayemntLoading(false)
                    }
                }).catch(err => {
                    console.log(err)
                    setNotificationMessage('Something went wrong, Please Try Again later!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsPayemntLoading(false)
                });
            } catch (error) {
                console.log("error",error);
                setNotificationMessage('Internal server Error. Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsPayemntLoading(false)
            }
        } else {
            setOpenPopup(false);
            setNotificationMessage('Please Add Some Event Type!');
            setOpenNotify(true);
            setAlertType('error');
        }
	};

	const openUserInfoPopup = async () => {
        let totalAmout = totalSum;
        if(totalAmout > 0) {
            setOpenPopup(true);
        } else {
            setNotificationMessage('Please Select Some Event Type!');
            setOpenNotify(true);
            setAlertType('error');
        }
	};

	const createPhonePeOrderRequest = async () => {
        let totalAmout = totalSum;
        if(totalAmout > 0) {
            setIsPayemntLoading(true)
            try {
                await server.post("/phonepe/payment", { 
                    name: eventDetails?.tournamentName,
                    amount: totalAmout * 100, 
                    MUID: "MUID" + Date.now(),
                    transactionId: 'T' + Date.now(),
                }).then((response) => {
                    console.log(response.data);
                    setTimeout(() => {
                        setIsPayemntLoading(false);
                    }, 1500);
                    if (response.status === 200 && response.data.success) {
                        console.log("Create Order Passed => ",response.data);
                        newPayment.amount = totalAmout * 100;
                        newPayment.currency = "INR";
                        newPayment.tickets = renderTickets;
                        newPayment.events = eventDetails;
                        newPayment.via = 'PhonePe';
                        newPayment.orderId = "MUID" + Date.now();
                        newPayment.orderId = 'T' + Date.now();
                        newPayment.paymentStatus = 'Created';
                        try {
                            var payment = createPaymentDocument(newPayment);
                            if (payment) {
                                history.push(`/payment-success`);
                            } else {
                                console.error("ERROR Occurs in Create Order Database Entry => ");
                                setNotificationMessage('Something went wrong, Please Try Again later!');
                                setOpenNotify(true);
                                setAlertType('error');
                                setIsPayemntLoading(false)
                                history.push('/payment-failed');
                            }
                        }  catch (error) {
                            console.error("ERROR Occurs in Create Order Entry => ", error);
                            setNotificationMessage('Something went wrong, Please Try Again later!');
                            setOpenNotify(true);
                            setAlertType('error');
                            setIsPayemntLoading(false)
                        }
                    } else {
                        setNotificationMessage('Something went wrong, Please Try Again later!');
                        setOpenNotify(true);
                        setAlertType('error');
                        setIsPayemntLoading(false)
                    }
                }).catch(err => {
                    console.log(err)
                    setNotificationMessage('Something went wrong, Please Try Again later!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsPayemntLoading(false)
                });
            } catch (error) {
                console.log("error",error);
                setNotificationMessage('Internal server Error. Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsPayemntLoading(false)
            }
        } else {
            setNotificationMessage('Please Add Some Event Type!');
            setOpenNotify(true);
            setAlertType('error');
        }
	};

    return (
        <>
            <div className="container-fluid mb-5">
                <AddMetaTags record={eventDetails} imageUrl={imageUrl} />
                {
                    eventDetails && eventDetails != null ? 
                    <div className="row">
                        <div className="col-lg-10 col-md-10 col-sm-12 mx-auto mt-5">
                            <div className="productDetail mt-5">
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="bookingDetail__companyInfo">
                                            {eventDetails && <h5 className="MainColor">{eventDetails?.tournamentName}</h5>}
                                            <p className="productDetail__title">By {eventDetails?.organizerName}, {eventDetails?.location}</p>
                                            <p className="productDetail__title"><b>{eventDetails?.startDate?.toDate()?.toDateString()}</b> onwards</p>
                                            <br />
                                        </div>
                                        <div className="row">
                                            {(eventDetails?.entryFeeFields && eventDetails?.entryFeeFields.length > 0) && <>
                                                {eventDetails?.entryFeeFields.map((entryFees, index) => {
                                                    return <div className="col-md-4 booking_col_box" key={index}>
                                                        <div className="booking__box mt-5">
                                                            <p className="booking__card productDetail__title">{entryFees.entryCategory}</p>
                                                            <div className="pricing__box total__amount">
                                                                <p className="leftText"> Rs. {entryFees.entryFees} </p>
                                                                <div className="d-flex btn__action">
                                                                    <Button type="button" variant="outlined" className="navbar__btnClear plus_minus" size="small" 
                                                                        onClick={()=> handleAddEntryFee(entryFees.uniqueId, entryFees.entryCategory, entryFees.entryFees, index)}>
                                                                        <PlusIcon className="mr-2" fontSize="small" />
                                                                    </Button>
                                                                    <Button type="button" variant="outlined" color="primary" className="navbar__btnClear plus_minus" size="small"
                                                                        onClick={()=> handleRemoveEntryFee(entryFees.uniqueId)}>
                                                                        <MinusIcon className="mr-2" fontSize="small" />
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })}
                                            </>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="bookingDetail__companyInfo">
                                            <div className="pricing__box">
                                                <p className="leftText"> Total Tickets </p>
                                                <p className="rightText"> <b>{entryTicketFields.length > 0 ? entryTicketFields.length : 0} </b></p>
                                            </div>
                                            <hr className="hr__sports" />
                                            {entryTicketFields.length > 0 && <>
                                                {renderTickets.map((tickets, index) => {
                                                    return <div className="pricing__box" key={index}>
                                                        <p className="leftText"> {tickets.entryCategory} </p>
                                                        <p className="rightText"> <b>{tickets.ticketCount}* Rs. {tickets.entryFees}</b> </p>
                                                    </div>
                                                })}
                                                </>
                                            }
                                        </div>
                                        <div className="pricing__box total__amount">
                                            <p className="leftText"> Total Amount </p>
                                            <p className="rightText"> Rs. {entryTicketFields.length > 0 ? totalSum : 0} </p>
                                        </div>
                                        <div className="mt-4">
                                            <div className="pay__btn">
                                                <Button 
                                                    variant="contained" 
                                                    color="primary" className="navbar__btnLogin"
                                                    onClick={()=> !isPayemntLoading ? openUserInfoPopup() : {}}>
                                                    {isPayemntLoading ? <CircularProgress size={18} /> : 'Next'}
                                                </Button>
                                            </div><br />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : <div className="row">
                        <div className="col-lg-10 col-md-10 col-sm-12 mx-auto mt-5">
                            <div className="productDetail mt-5 text-center justify-center">
                                <DetailsSkeleton />
                            </div>
                        </div>
                    </div>
                }
            </div>

            <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="Enter User  Details">
                <BookingUserInfo 
                    // createOrderRequest={createRazorpayOrderRequest}
                    createOrderRequest={createPhonePeOrderRequest}
                    isPayemntLoading={isPayemntLoading}  />
            </Popup>

            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default SportBookingDetails

